import { Button, Col, Form, Input, InputNumber, message, Modal, Radio, Row } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import "../Styles/payment.scss"
import { useEffect, useRef, useState } from "react";
import PdfDocument from "./PdfDocument";
import OctoletPdf from "./OctoletPdf";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver"; 
import PaymentDetailsTable from "./PaymentDetailsTable";
import PaymentModes from "./PaymentModes";
import { ENV } from '../config';
import { GeneratOrdertInvoice } from "./GeneratOrdertInvoice";



const PaymentsPage = () => {
  const [form] = Form.useForm();
  const sectionRef = useRef();

  const handlePrint = () => {
    const printContent = sectionRef.current.innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload(); // Reload page to restore original content
  };

  const query = new URLSearchParams(useLocation().search);
  const unid = query.get("unid");
  const [mode, setMode] = useState("mobile");
  const [modals, setModals] = useState({
    isModalOpen: false,
    showProductModal: false,
  });
  const [lo_recordForPrint, setRecordForPrint] = useState({});
  const [taxData, setTaxData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [placeOrderloading, setPlaceOrderLoading] = useState(false);
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (!unid) return; 
    fetchData();
  }, [unid]); 

  const formatNumberByCommas = (number) => {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(parseFloat(number));
  };


  const fetchData = async () => {
    try {

      const response = await fetch(`${ENV.REACT_APP_REST_API}/get-gi-details?unid=${unid}`);
      if (!response.ok) {
        navigate("/")
      }
        const result = await response.json();
        setRecordForPrint(result);

        const allproductData = result.service_info?.map((item, index) => ({
          sn: index + 1,
          itemCode: item.inventory?.item_code,
          itemName: item.prod_name,
          qty: item.qty,
          rate: formatNumberByCommas(item.prod_sellprice),
          taxableAmt: formatNumberByCommas(
            item.total_amount - item.inventory.tax_values.sales_vat_tax * item.qty
          ),
          taxAmt: formatNumberByCommas(
            item.inventory.tax_values.sales_vat_tax * item.qty
          ),
          totalAmt: formatNumberByCommas(item.total_amount),
        }));

        setProductData(allproductData)

        const alltaxData = [
        {
        taxRate: "16%",
        taxableAmt:
        "Ksh. " +
        result.service_info
        .filter((item) => item.prod_category.tax_rate === "16%")
        .reduce(
        (sum, item) =>
        sum +
        parseFloat(
          item.total_amount -
            item.inventory.tax_values.sales_vat_tax * item.qty
        ),
        0
        )
        .toFixed(2),
        taxAmt:
        "Ksh. " +
        result.service_info
        .filter((item) => item.prod_category.tax_rate === "16%")
        .reduce(
        (sum, item) =>
        sum +
        parseFloat(item.inventory.tax_values.sales_vat_tax * item.qty),
        0
        )
        .toFixed(2),
        totalAmt:
        "Ksh. " +
        result.service_info
        .filter((item) => item.prod_category.tax_rate === "16%")
        .reduce((sum, item) => sum + parseFloat(item.total_amount), 0)
        .toFixed(2),
        },
        {
        taxRate: "0%",
        taxableAmt:
        "Ksh. " +
        result.service_info
        .filter((item) => item.prod_category.tax_rate === "0%")
        .reduce(
        (sum, item) =>
        sum +
        parseFloat(
          item.total_amount -
            item.inventory.tax_values.sales_vat_tax * item.qty
        ),
        0
        )
        .toFixed(2),
        taxAmt:
        "Ksh." +
        result.service_info
        .filter((item) => item.prod_category.tax_rate === "0%")
        .reduce(
        (sum, item) =>
        sum +
        parseFloat(item.inventory.tax_values.sales_vat_tax * item.qty),
        0
        )
        .toFixed(2),
        totalAmt:
        "Ksh. " +
        result.service_info
        .filter((item) => item.prod_category.tax_rate === "0%")
        .reduce((sum, item) => sum + item.total_amount, 0)
        .toFixed(2),
        },
        {
        taxRate: "EX",
        taxableAmt:
        "Ksh. " +
        result.service_info
        .filter((item) => item.prod_category.tax_rate === "EX")
        .reduce(
        (sum, item) =>
        sum +
        parseFloat(
          item.total_amount -
            item.inventory.tax_values.sales_vat_tax * item.qty
        ),
        0
        )
        .toFixed(2),
        taxAmt:
        "Ksh. " +
        result.service_info
        .filter((item) => item.prod_category.tax_rate === "EX")
        .reduce(
        (sum, item) =>
        sum +
        parseFloat(item.inventory.tax_values.sales_vat_tax * item.qty),
        0
        )
        .toFixed(2),
        totalAmt:
        "Ksh. " +
        result.service_info
        .filter((item) => item.prod_category.tax_rate === "EX")
        .reduce((sum, item) => sum + item.total_amount, 0)
        .toFixed(2),
        },
        {
        taxRate: "TOTAL",
        taxableAmt:
        "Ksh. " +
        formatNumberByCommas(
        result.service_info
        .filter((item) => item.prod_category.tax_rate === "16%")
        .reduce(
        (sum, item) =>
          sum +
          parseFloat(
            item.total_amount -
              item.inventory.tax_values.sales_vat_tax * item.qty
          ),
        0
        )
        .toFixed(2)
        ),
        taxAmt:
        "Ksh. " +
        formatNumberByCommas(
        result.service_info
        .filter((item) => item.prod_category.tax_rate === "16%")
        .reduce(
        (sum, item) =>
          sum +
          parseFloat(item.inventory.tax_values.sales_vat_tax * item.qty),
        0
        )
        .toFixed(2)
        ),
        totalAmt:
        "Ksh. " +
        formatNumberByCommas(
        result.service_info
        .filter((item) => item.prod_category.tax_rate === "16%")
        .reduce((sum, item) => sum + parseFloat(item.total_amount), 0)
        .toFixed(2)
        ),
        },
        ];

        setTaxData(alltaxData);

    } catch (err) {
      navigate("/")
    } 
  };

  const selectMode = (name) => {
    setMode(name);
  };

  const updateModalState = (modalName, value) => {
    setModals((prevModals) => ({
      ...prevModals,
      [modalName]: value,
    }));
  };

  const placeOrder = () => {
      updateModalState("isModalOpen", true);
  };

  const downloadPdf = async () => {
  
    // Rows per page
    const ROWS_PER_PAGE = 15;

    // Helper to split data into pages
    const paginateData = (data, rowsPerPage) => {
      const pages = [];
      for (let i = 0; i < data?.length; i += rowsPerPage) {
        pages.push(data.slice(i, i + rowsPerPage));
      }
      return pages;
    };
  
  const pages = paginateData(productData, ROWS_PER_PAGE);
 
  const blob = await pdf(
    <OctoletPdf
    record={lo_recordForPrint}
    pages={pages}
    ROWS_PER_PAGE={ROWS_PER_PAGE}
    taxData={taxData}
  />
  ).toBlob();

  saveAs(blob, `Invoice_${lo_recordForPrint.order_no}.pdf`);
  
  };

  const handleCancel = () => {
      updateModalState("isModalOpen", false);   
  };

  const handleSubmitAndPrintReceipt = (type) => {
    // setReceiptRqType(type);
    form.submit();
  };

  const onCreditPaymentFinish = (values) => {
    setPlaceOrderLoading(true);
   updateModalState("isModalOpen", false);
    FinalOrder(values);
  };

  const handlePlaceOrder = async (finalData) => {

    const response = await fetch(`${ENV.REACT_APP_REST_API}/save-gi-payment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(finalData),
    });
    const data = await response.json();
    setPlaceOrderLoading(false);
    messageApi.open({
      type: 'success',
      content: 'Order has been placed successfully!',
    });

    generatePdf(data);
    
    
  };

  const generatePdf = async (data) => {

    let header = "NORMAL SALES RECEIPT";
    let copy = false;
    let image = "images/logo.jpg";
    let blob = await pdf(
        <GeneratOrdertInvoice
          record={data}
          currency='Ksh'
          imageUrl={image}
          qrCodeBaseUrl={ENV.QR_CODE_URL}
          header={header}
          copy={copy}
        />
      ).toBlob();

    var url = URL.createObjectURL(blob);
    window.open(url, "_blank");

    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = async function () {
      var base64String = reader.result.split(",")[1]; // Remove the data URL prefix
      data.pdfBuffer = base64String; // Store it properly

      const response = await fetch(`${ENV.REACT_APP_REST_API}/send-gi-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const ResultData = await response.json();
      fetchData();

    };

  };

  const FinalOrder = async (paymentValues = {}) => {
    let finalData = {
      ...lo_recordForPrint,
      ...paymentValues,
      payment_status: "Paid",
      transaction_type:"N",
      payment_mode:mode,
    };

    const response = await fetch(`${ENV.REACT_APP_REST_API}/make-gi-payment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(finalData),
    });
    const result = await response.json();
    console.log("result===>",result);
    const checkoutRequestID = result?.CheckoutRequestID;
    // const checkoutRequestID = "ws_CO_20022025215753690713605757";
    if (checkoutRequestID) {
      finalData.checkoutRequestID = checkoutRequestID;
      const interval = setInterval(  async () => {
        const paymentResponse = await fetch(`${ENV.REACT_APP_REST_API}/get-payment-check?checkoutRequestID=${checkoutRequestID}`);
        const resultData = await paymentResponse.json();
        console.log("resultData===>",resultData);
          if(resultData._id) {
          clearInterval(interval);
          clearTimeout(timeout);
          messageApi.open({
            type: 'success',
            content: 'Payment has been done successfully!',
          });
          return handlePlaceOrder(finalData);
          }
        
      }, 1000);
      

      const timeout = setTimeout(() => {
        setPlaceOrderLoading(false);
        clearInterval(interval);
        messageApi.open({
          type: 'error',
          content: 'Payment Failed!',
        });
        updateModalState("isModalOpen", true);
      }, 50000);
    } else {
      setPlaceOrderLoading(false); 
      messageApi.open({
        type: 'error',
        content: 'Payment Failed!',
      });
      updateModalState("isModalOpen", true);
    }

  };

   const handleReceipt = async () => {
    setPlaceOrderLoading(true);
    let finalData = lo_recordForPrint;

    const response = await fetch(`${ENV.REACT_APP_REST_API}/pdf-gi-details`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(finalData),
    });

    const data = await response.json();
    setPlaceOrderLoading(false);
    generatePdf(data);

  };

  return (
    <>
    {contextHolder}
 <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
  {/* Header Section (Sticky) */}
  <div style={{ position: "sticky", top: 0, background: "white", zIndex: 1000, paddingBottom: "10px" }}>
    <Row gutter={[24, 10]} justify="center">
      <Col lg={16}>
      <PaymentDetailsTable lo_recordForPrint={lo_recordForPrint}/>
      </Col>
      <Col lg={8}>
       <PaymentModes  mode={mode} selectMode={selectMode} />
        <div className="place__box" style={{ display: "flex", gap: "10px" }}>
         {(lo_recordForPrint.payment_status == "Due") ? <><Button type="primary" className="order-btn" loading={placeOrderloading} onClick={placeOrder}>
            Make Payment
          </Button></> : <><Button type="primary" className="order-btn" loading={placeOrderloading} onClick={handleReceipt}>
           View Sales Receipt
          </Button></>}
          
          <Button type="primary" className="download-btn" onClick={downloadPdf}>
            Download Pdf
          </Button>
          <Button type="primary" className="print-btn"  onClick={handlePrint}>
            Print Pdf
          </Button>
        </div>
      </Col>
    </Row>
  </div>

  {/* PDF Scrollable Section */}
  <div ref={sectionRef} style={{ flex: 1, overflowY: "auto", padding: "10px", border: "1px solid #ddd" }}>
    <Row justify="center">
      <Col span={24} style={{ display: "flex", justifyContent: "center" }}>
        <PdfDocument record={lo_recordForPrint} productData={productData} taxData={taxData} />
      </Col>
    </Row>
  </div>

</div>

<Modal
       title={`Payment Method: Mobile`}
        open={modals.isModalOpen}
        //onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <>
        <Button
          key="prompt-payment"
          type="primary"
          className="receipt-pdf-btn"
          onClick={() => {
            handleSubmitAndPrintReceipt("auto-generate-invoice");
          }}
        >
          <div className="printButtonAlign">Prompt Payment</div>
        </Button>    
        </>
        ]}
        cancelButtonProps={{
          type: "danger",
        }}
        width={850}
      >
        <div>
        <Form
          form={form}
          name="credit-hooks"
          initialValues={{
            payment_type: "Mpesa Express",
          }}
          className="payment-form"
          onFinish={onCreditPaymentFinish}
        >
      <div className="border-div-transaction" style={{ marginTop: "15px" }}>
        <Form.Item
          colon={false}
          label={
            <div style={{ textAlign: "center", marginTop: "15px" }}>
              <b className="new-font-margin">Total Amount(KSH):</b>
            </div>
          }
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
        >
          <Input
            className="amount_received"
            // ref={amountReceivedRef}
            autoComplete="off"
            disabled="disabled"
            value={lo_recordForPrint.total_amount}
          />
        </Form.Item>


        <Form.Item
          colon={false}
          label={
            <div style={{ textAlign: "center", marginTop: "15px" }}>
              <b className="new-font-margin">Due Amount(KSH):</b>
            </div>
          }
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
        >
          <Input
            className="amount_received_red"
            autoComplete="off"
            disabled="disabled"
            value={lo_recordForPrint.total_amount}
          />
        </Form.Item>
     
        <Form.Item
          colon={false}
          label={<b className="new-font">Payment Type:</b>}
          name="payment_type"
          rules={[
            {
              required: true,
              message: "Please choose payment type!",
            },
          ]}
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
        >
            <Radio.Group buttonStyle="solid" size="large">
              <Radio.Button value="Mpesa Express">Mpesa Express</Radio.Button>
            </Radio.Group>
        </Form.Item>
        
          <Form.Item
          colon={false}
          label={
          <div style={{ textAlign: "center", marginTop: "15px" }}>
          <b className="new-font-margin">Phone No.:</b>
          </div>
          }
          name="mobile_no"
          rules={[
            {
              required: true,
              message: "Please Enter Phone No.!",
            },
          ]}
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          >
          <InputNumber
          className="amount_received"
          autoComplete="off"
          />
          </Form.Item>
       
      </div>
        </Form>  
        </div>

      </Modal>
    </>

  );
};

export default PaymentsPage;